import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { LoadingScreen } from '../../../UiComponents/LoadingComponent';
import { sbaAxios } from '../../../utils/sbaAxios';
import { getPrivateExposureAssetList, getPrivateTemplateByAsset, getPrivateTemplateCategories, getUserPageAccess, updatePrivateTemplateByAsset } from '../../../../config/apiConfig';
import { SBAComboBox } from '../../../UiComponents/SBADropDown';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getAsset } from '../../../actions/assetAction';
import { UrlPath } from '../../../../config/routeConfig';
import { SBTreeView } from '../../../UiComponents/SBTreeView';
import { SBNotify } from '../../../utils/sbNotify';
import { Unauthorized } from '../../../shared/ErrorPage/ErrorPage';



const Configuration = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useNavigate();
  const Gstate =
  useSelector((state) => {
    return state;
  }) || {};
  const currentAsset = Gstate.asset.asset || {};
  const [accessConfiguration,setConfigurationAccess]=useState({isLoading:true,isAccessible:false});
  // const [selectedCategory,setSelectedCategory]
   const [categoryList,setCategoryList]=useState([]);
   const [selectedOption,setSelectedOption]=useState(null);
  const [AssetListData, setAssetListData] = useState([]);
  const [selectedCategory,setSelectedCategory]=useState([]);
  const [filterCategory,setFilteredCategory]=useState([]);
  const [filterCategory1,setFilteredCategory1]=useState([]);
  useEffect(()=>{
    assetListData();
    getSelectedCategories(params.Asset);
    getCategories();
    document.title="Exposure";
    sbaAxios({ url: `${getUserPageAccess}?keyName=ExposureConfigurationAccess` }).then(res=>{setConfigurationAccess({isAccessible:res,isLoading:false})}).catch(()=>{setConfigurationAccess({isAccessible:false,isLoading:false})});
  },[]);
  useEffect(()=>{
    dispatch(getAsset(params.Asset));
  },[params.Asset]);
const AssestDDChanged = (e) => {
  if(e.value)
  {
    history(`${UrlPath.PrivateExposure}${e.value.AssetId}`);
    setFilteredCategory([]);
    setFilteredCategory1([]);
    setSelectedOption(null);
    getSelectedCategories(e.value.AssetId);
  }
};

const getCategories=async()=>{
  try {
    const response = await sbaAxios({
      url: `${getPrivateTemplateCategories}`,
      method: "get",
    });
   setCategoryList(response);
  } catch (error) {
    
  }
}
const getSelectedCategories=async(assetId)=>{
  try {
    const response = await sbaAxios({
      url: `${getPrivateTemplateByAsset}${assetId}`,
      method: "get",
    });
   setSelectedCategory(response);
  } catch (error) {
    
  }
}
const assetListData = async () => {
  try {
    const response = await sbaAxios({
      url: `${getPrivateExposureAssetList}`,
      method: "get",
    });
    const data = response;
    setAssetListData(data);
  } catch (error) {
    console.error("Error fetching assetListData from API:", error);
  }
  };
  const onRowClick = (e) => {
    if (e.value) {
        setSelectedOption(e.value);
        const childExposure=selectedCategory.filter(item=>item.RootExposureId!=item.ExposureId).map(item=>({
          id: item.ExposureId,
          text: item.ExposureName,
          expanded: true,
          checked: false,
          items: [],
          editable: item.AssetId == null,
          level:3,
          checked:item.checked || item.AssetId!=0,
          disabled:item.IsLocked,
          ...item
        }));
        const filteredData = selectedCategory
          .filter(item => item.ParentExposureId === e.value?.ParentExposureId && item.RootExposureId==item.ExposureId)
          .map(item => ({
            id: item.ExposureId,
            text: item.ExposureName,
            expanded: true,
            checked: false,
            items: childExposure.filter(sItem => sItem.RootExposureId == item.ExposureId),
            editable: item.AssetId == null,
            level: 2,
            checked: item.checked || item.AssetId != 0,
            disabled: item.IsLocked,
            ...item
          }));
        const updatedTreeData = [{
          id: e.value.ParentExposureId,
          text: e.value.ParentExposureName,
          expanded: true,
          checked: false,
          level:1,
          items: filteredData,
          checked:false,
          disabled:false,
        }];
      setFilteredCategory((val) => updatedTreeData);
      setFilteredCategory1((val) => updatedTreeData);
    }

};

const updatePrivateTemplate=(item)=>{
  const data=
  {
    "assetId": parseInt(params.Asset),
    "exposureId": item.ExposureId,
    "parentExposureId": item.ParentExposureId,
    "isChecked": !item.checked,
    "userId": 0
  }
  sbaAxios({url:updatePrivateTemplateByAsset,method:'post',data}).then(res=>{
    SBNotify({Msg:"Template Status Updated Successfully"});
    const category=selectedCategory.map(items=>{
      if(items.ExposureId==item.ExposureId && items.ParentExposureId==item.ParentExposureId)
      {
        return {...items,checked:!item.checked}
      }
      return {...items}
    });
    setSelectedCategory(val=>category);
  
  }).catch(error=>{});


}
const handleExpandChange=(e)=>{
  if(e.item.level==1)
  {
    // if(e.item)
    // {
    //   setFilteredCategory(prevState => 
    //     prevState.map(group => ({
    //       ...group,
    //       expanded: !group.expanded
    //     }))
    //   );
    //   setFilteredCategory1(prevState => 
    //     prevState.map(group => ({
    //       ...group,
    //       expanded: !group.expanded
    //     }))
    //   );
    // }
    
  }
  else if (e.item.level == 2) {
    if(e.item)
    {
      
      
      setFilteredCategory(prevState => 
        prevState.map(group => ({
          ...group,
          items:group.items.map(item=>{
            if(item.ExposureId==e.item.ExposureId)
            {
              return {...item,expanded:!item.expanded}
            }
            else return {...item}
          }),
       
        }))
      );
      setFilteredCategory1(prevState => 
        prevState.map(group => ({
          ...group,
          items:group.items.map(item=>{
            if(item.ExposureId==e.item.ExposureId)
            {
              return {...item,expanded:!item.expanded}
            }
            else return {...item}
          }),
        
        }))
      );
    }
  }
};
const saveSetting=(exposureItem)=>{

};
const handleCheckChange = (e) => {
  const { item } = e;
  const isLocked = selectedCategory.find(i => i.ExposureId === item.ExposureId)?.IsLocked;
  if (!isLocked && item.level==1 ) {
    setFilteredCategory(prevState => 
      prevState.map(group => ({
        ...group,
        items: group.items.map(i =>
          i.ExposureId === item.ExposureId ? { ...i, checked: !i.checked } : i
        )
      }))
    );
    

    setFilteredCategory1(prevState => 
      prevState.map(group => ({
        ...group,
        items: group.items.map(i =>
          i.ExposureId === item.ExposureId ? { ...i, checked: !i.checked } : i
        )
      }))
    );
    
  }
  if (!isLocked && item.level==3 ) {
    updatePrivateTemplate(item);
    setFilteredCategory(prevState => 
      prevState.map(group => ({
        ...group,
        items: group.items.map(i =>
          {
          
            if(i.ExposureId==item.RootExposureId)
            {
                return {...i,items:i.items.map(si=>{
                return si.ExposureId === item.ExposureId ? { ...si, checked: !si.checked } : si
                }
                )}
            }
            else return i
          }
        )
      }))
    );
    

    setFilteredCategory1(prevState => 
      prevState.map(group => ({
        ...group,
        items: group.items.map(i =>
          {
          
            if(i.ExposureId==item.RootExposureId)
            {
                return {...i,items:i.items.map(si=>{
                return si.ExposureId === item.ExposureId ? { ...si, checked: !si.checked } : si
                }
                )}
            }
            else return i
          }
        )
      }))
    );
    
  }
  if(!isLocked && item.level==2)
  {
    updatePrivateTemplate(item);
    setFilteredCategory(prevState =>
      prevState.map(group => ({
        ...group,
        items: group.items.map(i =>
          i.ExposureId === item.ExposureId ? { ...i, checked: !i.checked } : i
        )
      }))
    );
    setFilteredCategory1(prevState =>
      prevState.map(group => ({
        ...group,
        items: group.items.map(i =>
          i.ExposureId === item.ExposureId ? { ...i, checked: !i.checked } : i
        )
      }))
    );
  }
};

const handleFilterChange = (value) => {
  const filterTree = (items, query) => {
      return items
          .map(item => {
              const isMatch = item.text?.toLowerCase().includes(query.toLowerCase());
              const filteredChildren = item.items ? filterTree(item.items, query) : [];

              if (isMatch || filteredChildren.length > 0) {
                  return {
                      ...item,
                      items: filteredChildren.length > 0 ? filteredChildren : item.items
                  };
              }
              return null;
          })
          .filter(Boolean);
  };

  const filteredRecords = filterTree(filterCategory1, value);
  setFilteredCategory(filteredRecords);
};
  return (
    <>
      {accessConfiguration.isLoading ? (
        <LoadingScreen />
      ) : accessConfiguration.isAccessible ? (
        <>
            <div className="row my-3">
              <div className="col-md-3">
                <label className="mb-1 ms-2 fw-semibold fs-12">Asset</label>
                <div>
                  <SBAComboBox
                    filterable={true}
                    data={AssetListData}
                    textField="AssetName"
                    valueField="AssetId"
                    value={currentAsset}
                    onChange={AssestDDChanged}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <label className="mb-1 ms-2 fw-semibold fs-12">Category</label>
                <div>
                  <SBAComboBox
                    filterable={true}
                    data={categoryList}
                    textField="ParentExposureName"
                    valueField="ParentExposureId"
                    value={selectedOption}
                    onChange={(e)=>{onRowClick(e)}}
                  />
                </div>
              </div>
              <div className='col-md-6'>
              <label className="mb-1 ms-2 fw-semibold fs-12"></label>

                <div className='my-1'>
                  <input type='text' className='form-control w-100' placeholder='Please enter to search...' onChange={(e)=>{handleFilterChange(e.target.value)}}/>
                </div>
              <div className='w-100' style={{ maxHeight: "500px", overflowY: 'scroll' , overflowX:'hidden' }}>
                <SBTreeView
                  className="SBTreeView"
                  data={filterCategory.map(item => ({ ...item }))}
                  expandIcons={true}
                  checkboxes={(e)=>e.item.level==3}
                  onExpandChange={(e) => {handleExpandChange(e) }}  
                  onCheckChange={(e) => {handleCheckChange(e) }} 
                  disableField={"disabled"}
                  checkField={"checked"}
                  // itemRender={CustomTreeItem}
                  // item={(props) => (
                  //   <ConfigurationCheckBox {...props} onCheckChange={handleCheckChange} />
                  // )}
                />
              </div>
              </div>
            </div>
            <div > <div className='d-flex'>
            
            </div>
              <div >
               
                <>
                </>
              </div>
            </div>  
        </>
      ) : (
        <><Unauthorized /></>
      )}
    </>
  );
};

const ConfigurationCheckBox = ({ item, itemHierarchicalIndex, onCheckChange }) => {
  return (
    <div className="custom-tree-item">
      {item.items?.length === 0 && <input
        type="checkbox"
        checked={item.checked || item.AssetId!=0}
        onChange={(e) => onCheckChange({ item, value: e.target.checked })}
        className={item.IsLocked ? 'opacity-50 mx-2 '  :'mx-2' }
      />}
      <span className={item.IsLocked && 'opacity-50'}>{item.text}</span>
    </div>
  );
};
const CustomTreeItem = (props) => {
  const { item, itemHierarchicalIndex } = props;

  const isParent = item.items && item.items.length > 0; // Check if parent node
  return (
      <div style={{ 
          padding: '8px 12px', 
          fontWeight: isParent ? 'bold' : 'normal', 
          color: isParent ? 'blue' : 'black' 
      }}>
          {isParent ? `📁 ${item.text}` : `📄 ${item.text}`}
      </div>
  );
};

export default Configuration;
